import useUserStore from "@/state/user/useUserStore";
import React, { useEffect } from "react";
import { Disc3, Eye, GraduationCap, Shirt, Smile } from "lucide-react";
import { PostPage } from "@/components/formats/post-page";
import { Asset } from "@/types/types";

export const ThcPage = () => {
  const [setSelectedImage, assetsCount, setUploadAssets] = useUserStore((state) => [
    state.setSelectedImage,
    state.assetsCount,
    state.setUploadAssets,
  ]);

  const HeadAssets = Array.from(
    { length: assetsCount?.base },
    (_, i) => `/Mememaker/base/base${i + 1}.png`
  );

  const ClothingAssets = Array.from(
    { length: assetsCount?.clothing },
    (_, i) => `/Mememaker/clothing/clothing${i + 1}.png`
  );

  const FaceAssets = Array.from(
    { length: assetsCount?.headgear },
    (_, i) => `/Mememaker/headgear/headgear${i + 1}.png`
  );

  const EyeAssets = Array.from(
    { length: assetsCount?.face },
    (_, i) => `/Mememaker/face/face${i + 1}.png`
  );

  const MiscAssets = Array.from(
    { length: assetsCount?.misc },
    (_, i) => `/Mememaker/misc/misc${i + 1}.png`
  ).reverse();

  const allAssets: Asset[] = [
    { assets: HeadAssets, icon: <Smile /> },
    { assets: ClothingAssets, icon: <Shirt /> },
    { assets: FaceAssets, icon: <GraduationCap /> },
    { assets: EyeAssets, icon: <Eye /> },
    { assets: MiscAssets, icon: <Disc3 /> },
  ];

  useEffect(() => {
    setUploadAssets([]);
  }, []);

  return (
    <>
      <PostPage
        color="#eeba02"
        assets={allAssets}
        twitter="The_HoneyCast"
        defaultImg="/Mememaker/thc/thc.png"
      />
    </>
  );
};
